const CUSTOM_PERMISSION_NAMES = {
  PUBLIC_READ: 'PUBLIC_READ',
  NOT_OWNER_ORG: 'NOT_OWNER_ORG',
  OWNER_ORG: 'OWNER_ORG',
  NOT_OWNER_STREAM: 'NOT_OWNER_STREAM',
  OWNER_STREAM: 'OWNER_STREAM',
  NOT_OWNER_CHANNEL: 'NOT_OWNER_CHANNEL',
  OWNER_CHANNEL: 'OWNER_CHANNEL',
  NOT_OWNER_STREAMITEM: 'NOT_OWNER_STREAMITEM',
  OWNER_STREAMITEM: 'OWNER_STREAMITEM',
  NOT_OWNER_COMMENT: 'NOT_OWNER_COMMENT',
  OWNER_COMMENT: 'OWNER_COMMENT',
};

const PLATFORM_PERMISSION_NAMES = {
  PLATFORM_AGGREGATE_ADMIN: 'PLATFORM_AGGREGATE_ADMIN',
  PLATFORM_TOPIC_ADMIN: 'PLATFORM_TOPIC_ADMIN',
};

export const PERMISSION_NAMES = {
  ...CUSTOM_PERMISSION_NAMES,
  ...PLATFORM_PERMISSION_NAMES,
  OWNER_READ: 'OWNER_READ',
  ROLE_DELETE: 'ROLE_DELETE',
  ROLE_CREATE: 'ROLE_CREATE',
  ROLE_ASSIGN: 'ROLE_ASSIGN',
  CHANNEL_CREATE: 'CHANNEL_CREATE',
  CHANNEL_DELETE: 'CHANNEL_DELETE',
  CHANNEL_MANAGE: 'CHANNEL_MANAGE',
  CHANNEL_READ: 'CHANNEL_READ',
  CHANNEL_UPDATE: 'CHANNEL_UPDATE',
  CHANNEL_BROWSE: 'CHANNEL_BROWSE',
  MEMBER_CREATE: 'MEMBER_CREATE',
  MEMBER_DELETE: 'MEMBER_DELETE',
  MEMBER_BROWSE: 'MEMBER_BROWSE',
  STREAMITEM_CREATE: 'STREAMITEM_CREATE',
  STREAMITEM_READ: 'STREAMITEM_READ',
  STREAMITEM_UPDATE: 'STREAMITEM_UPDATE',
  STREAMITEM_DELETE: 'STREAMITEM_DELETE',
  STREAMITEM_BROWSE: 'STREAMITEM_BROWSE',
  STREAMITEM_TAG: 'STREAMITEM_TAG',
  STREAMITEM_PUBLISH: 'STREAMITEM_PUBLISH',
  STREAMITEM_TIMELINE_SEND: 'STREAMITEM_TIMELINE_SEND',
  STREAMITEM_REBUZZ_CONTROL: 'STREAMITEM_REBUZZ_CONTROL',
  STREAMITEM_ARCHIVE: 'STREAMITEM_ARCHIVE',
  STREAMITEM_LOCK: 'STREAMITEM_LOCK',
  STREAMITEM_BOOST_ADD: 'STREAMITEM_BOOST_ADD',
  STREAMITEM_BOUNTY_ADD: 'STREAMITEM_BOUNTY_ADD',
  STREAMITEM_PIN: 'STREAMITEM_PIN',
  STREAMITEM_COMMENT_CONTROL: 'STREAMITEM_COMMENT_CONTROL',
  STREAMITEM_THREAD_CREATE: 'STREAMITEM_THREAD_CREATE',
  COMMENT_READ: 'COMMENT_READ',
  COMMENT_CREATE: 'COMMENT_CREATE',
  COMMENT_DELETE: 'COMMENT_DELETE',
  COMMENT_MANAGE: 'COMMENT_MANAGE',
  STREAM_READ: 'STREAM_READ',
  STREAM_BROWSE: 'STREAM_BROWSE',
  STREAM_CREATE: 'STREAM_CREATE',
  STREAM_UPDATE: 'STREAM_UPDATE',
  STREAM_DELETE: 'STREAM_DELETE',
  INVITE_CREATE: 'INVITE_CREATE',
  INVITE_BROWSE: 'INVITE_BROWSE',
  INVITE_DELETE: 'INVITE_DELETE',
  ORG_READ: 'ORG_READ',
  ORG_UPDATE: 'ORG_UPDATE',
  RSS_MANAGE: 'RSS_MANAGE',
  RSS_READ: 'RSS_READ',
  // Messenger
  CHAT_ADMIN: 'CHAT_ADMIN',
  CHAT_MANAGE: 'CHAT_MANAGE',
  CHAT_READ: 'CHAT_READ',
  CHAT_WRITE: 'CHAT_WRITE',
  CHAT_UPDATE: 'CHAT_UPDATE',
};
